import { IonContent, IonPage, useIonViewWillEnter } from "@ionic/react";
import React, { useContext, useEffect } from "react";

import { ICareerSheetAnswer } from "../../../state";
import {
  Context,
  fetchCareerLatestSheet,
  fetchCareerSheets,
  saveCareerSheetAnswers,
  applyForCareerMapGeneration,
  CREATE_CAREER_SHEETS_SUCCESS_MESSAGE,
  SAVE_CAREER_SHEET_ANSWERS_SUCCESS_MESSAGE,
  SAVE_CAREER_SHEET_ANSWERS_FAILURE_MESSAGE,
  APPLY_FOR_CAREER_MAP_GENERATION_SUCCESS_MESSAGE,
  APPLY_FOR_CAREER_MAP_GENERATION_FAILURE_MESSAGE,
} from "../../../store/student";
import useToast from "../../../hooks/useToast";
import Toast from "../../../molecules/Toast";
import LoginHeader from "../../../organisms/LoginHeader";
import CareerSheet from "../../../templates/CareerSheet";
import styles from "../common.module.scss";

const CareerSheetPage = () => {
  const { contextState, dispatch } = useContext(Context);
  const { toast, setToast, handleToast } = useToast();

  useIonViewWillEnter(() => {
    if (contextState.career_latest_sheet?.term_no > 0) return;
    dispatch(fetchCareerLatestSheet());
    dispatch(fetchCareerSheets());
  });

  useEffect(() => {
    if (contextState.success_message === CREATE_CAREER_SHEETS_SUCCESS_MESSAGE) {
      dispatch(fetchCareerLatestSheet());
      dispatch(fetchCareerSheets());
    }
  }, [dispatch, contextState.success_message]);

  useEffect(() => {
    const successMessages = [
      SAVE_CAREER_SHEET_ANSWERS_SUCCESS_MESSAGE,
      APPLY_FOR_CAREER_MAP_GENERATION_SUCCESS_MESSAGE,
    ];
    const errorMessages = [
      SAVE_CAREER_SHEET_ANSWERS_FAILURE_MESSAGE,
      APPLY_FOR_CAREER_MAP_GENERATION_FAILURE_MESSAGE,
    ];

    handleToast("success", contextState.success_message, successMessages);
    handleToast("danger", contextState.error, errorMessages);
  }, [contextState.success_message, contextState.error, handleToast]);

  const saveCareerSheetAnswersFunc = (
    id: number,
    answers: ICareerSheetAnswer[],
  ) => {
    dispatch(saveCareerSheetAnswers(id, answers));
  };

  const applyForCareerMapGenerationFunc = (id: number) => {
    dispatch(applyForCareerMapGeneration(id));
  };

  return (
    <IonPage>
      <Toast
        type={toast.type}
        showToast={toast.isShow}
        onClose={() => setToast({ ...toast, isShow: false })}
        message={toast.message}
      />
      <LoginHeader title="キャリア開拓モード" unreadNotiCount={0} />
      <IonContent className={styles.wrapper}>
        <div className={styles.container}>
          <CareerSheet
            saveCareerSheetAnswers={saveCareerSheetAnswersFunc}
            applyForCareerMapGeneration={applyForCareerMapGenerationFunc}
          />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default CareerSheetPage;
